module.exports = __webpack_public_path__ + "img/Porto Apartment - 72 of 85.7670565e.jpeg";